/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/getContextKindsByProjectKeyOverrides';

export type GetContextKindsByProjectKeyPathParams = NonNullable<
  operations['getContextKindsByProjectKey']['parameters']['path']
>;

export type GetContextKindsByProjectKeyQueryParams = NonNullable<
  operations['getContextKindsByProjectKey']['parameters']['query']
>;

export interface Input extends GetContextKindsByProjectKeyPathParams {
  apiVersion?: string;
  query?: GetContextKindsByProjectKeyQueryParams;
}

export async function getContextKindsByProjectKey(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/context-kinds', {
    params: { path, query },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
